var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Your Address")]),_c('vue-google-autocomplete',{ref:"address",attrs:{"id":"map","classname":"form-control","placeholder":"Please type your address","country":"it"},on:{"placechanged":_vm.getAddressData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }